import Quickview from './Quickview'

export default {
  Quickview
}



// WEBPACK FOOTER //
// ./src/app/configuration/Demo/AutoDashboard/theme/components/quickview/index.js